import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query';

import {
  createChatAnnouncement,
  createChatBan,
  CreateChatBanParams,
  deleteChatMessage,
  getTopicChatChannel,
} from '../api';
import {
  QUERY__CHAT_TOPIC_CHANNEL,
  QUERY__CHAT_TOPIC_MESSAGES,
} from '../queryKeys';

export const useGetTopicChatChannel = (topicSlug: string) => {
  return useQuery({
    queryKey: [QUERY__CHAT_TOPIC_CHANNEL, topicSlug],
    queryFn: () => getTopicChatChannel(topicSlug),
    enabled: !!topicSlug,
  });
};

export const useDeleteChatMessage = (topicSlug: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      channelId,
      messageId,
    }: {
      channelId: string;
      messageId: string;
    }) => deleteChatMessage(channelId, messageId),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [QUERY__CHAT_TOPIC_MESSAGES, {topicSlug}],
      });
    },
  });
};

export const useCreateChatBan = () => {
  return useMutation({
    mutationFn: (params: CreateChatBanParams) => createChatBan(params),
  });
};

export const useCreateChatAnnouncement = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({channelId, text}: {channelId: string; text: string}) =>
      createChatAnnouncement(channelId, text),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [QUERY__CHAT_TOPIC_MESSAGES],
      });
    },
  });
};
